import { WebGroupsFeatures } from "./types/internal";

class WebGroupsFeatureDetector {
    public isFeatureSupported(feature: WebGroupsFeatures): boolean {
        switch (feature) {
            case "internal-universal-popups":
                return true;
            default:
                return false;
        }
    }
}

export default new WebGroupsFeatureDetector();